import * as model from "@/model/master/processConf/ProcessOption";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

const baseStore = newEntityStoreHelper(() => new model.ProcessOption(), newFilter).buildStore();

function date2str(date) {
    let year = date.getFullYear();
    let month = date.getMonth();
    let d = date.getDate();
    return `${year}-${month + 1}-${d}`;
}

function time2str(time) {
    let date = new Date;
    let year = date.getFullYear();
    let month = date.getMonth();
    let d = date.getDate();
    let h = time.getHours();
    let m = time.getMinutes();
    let s = time.getSeconds();
    return `${year}-${month + 1}-${d} ${h}:${m}:${s}`;
}

const baseUrl = process.env.VUE_APP_MASTER_API_URL + "master-service/master";

const processOptionStore = {
    namespaced: true,
    state: {
        baseModuleUrl: baseUrl,
        currentProcessOption: {},
    },
    mutations: {
        setCurrentProcessOption(state, data) {
            state.currentProcessOption = data;
        },
    },
    actions: {
        getChartData(context,checked){
            return context.dispatch('api/post', {
                url: baseUrl + '/processOption/getChartData',
                data:{id:checked}
            }, {root: true})
        },
        jumpToEdit(context, item) {
            context.commit("processOption/setCurrentProcessOption", item, {
                root: true
            });
            router.push({
                name: "processOptionEdit"
            });
        },
        findAll(context) {
            return context.dispatch('api/post', {
                url: baseUrl + '/processOption/findAll',
            }, {
                root: true,
            });
        },
        findPage(context, {index, size}) {
            const data = new FormData();
            data.append('page', index)
            data.append('size', size)

            return context.dispatch('api/post', {
                url: baseUrl + '/processOption/findPage',
                data,
            }, {
                root: true,
            });
        },
        deleteById(context, id) {
            const data = new FormData();
            data.append('id', id)
            return context.dispatch('api/post', {
                url: baseUrl + '/processOption/delete',
                data,
            }, {
                root: true,
            });
        },
        getLength(context) {
            return context.dispatch('api/post', {
                url: baseUrl + '/processOption/getLength',
            }, {root: true})
        },
        saveCurrentProcessOption(context) {
            return context.dispatch('saveProcessOption', context.state.currentProcessOption);
        },
        saveProcessOption(context, processOption) {
            let data = new FormData();
            let id = processOption.id > 0 ? processOption.id : -1;
            data.append('id', id);
            data.append('name', processOption.name);
            data.append('locationId', processOption.locationId);
            data.append('locationName', processOption.locationName);

            data.append('parentProcessOptionId', processOption.parentProcessOptionId);
            data.append('parentProcessOptionName', processOption.parentProcessOptionName);

            data.append('childProcessOptionId', processOption.childProcessOptionId);
            data.append('childProcessOptionName', processOption.childProcessOptionName);

            return context.dispatch('api/post', {
                url: baseUrl + '/processOption',
                data,
            }, {
                root: true,
            })
        }
    }
}

export default _.defaultsDeep(processOptionStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)
